module.exports = __webpack_public_path__ + "img/close-modal-image.fb783d23.svg";